module.exports = __webpack_public_path__ + "img/MuteShape.6ccc0b43.png";